//获取滚动条当前的位置
function getScrollTop() {
    var scrollTop = 0;
    if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
    } else if (document.body) {
        scrollTop = document.body.scrollTop;
    }
    return scrollTop;
}

//获取当前可视范围的高度
function getClientHeight() {
    var clientHeight = 0;
    if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
    } else {
        clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
    }
    return clientHeight;

}

//获取文档完整的高度
function getDocHeight() {
    return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
}
exports.init = function(){
    var current = getScrollTop() + getClientHeight();
    // 到达底部返回true
    if (getScrollTop() + getClientHeight() + 20 >= getDocHeight()) {
        return true;
    } else {
        return false;
    }
}


/** WEBPACK FOOTER **
 ** ./src/libs/isScrollBottom.js
 **/